/**
 * Icon button types
 */

export const ICON_BUTTON_RADIUS = {
    NONE: "none",
    SMALL: "small",
    ROUND: "round",
} as const;

/**
 * Icon button radius
 */
export type IconButtonRadius =
    (typeof ICON_BUTTON_RADIUS)[keyof typeof ICON_BUTTON_RADIUS];

export const ICON_BUTTON_VARIANT = {
    FILLED: "filled",
    OUTLINED: "outlined",
    GHOST: "ghost",
} as const;

/**
 * Icon button variant
 */
export type IconButtonVariant =
    (typeof ICON_BUTTON_VARIANT)[keyof typeof ICON_BUTTON_VARIANT];

export const ICON_BUTTON_COLOR = {
    PRIMARY: "primary",
    SECONDARY: "secondary",
    TERTIARY: "tertiary",
} as const;

/**
 * Icon button color
 */
export type IconButtonColor =
    (typeof ICON_BUTTON_COLOR)[keyof typeof ICON_BUTTON_COLOR];

export type CssSize = `${number}px` | `${number}rem`;

/**
 * Icon svg viewBox size ["height_in_px", "width_in_px"]
 */
export type IconSvgSize = [CssSize, CssSize];
